import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { environment } from '@uw-env/environment';
import { SUGGESTED_AMOUNT_SERVICE_ENTITY_CONFIG } from '@uw/injection-tokens/suggested-amount-service-entity.token';
import { Observable, map } from 'rxjs';
import { PaymentMethod } from '../models/payment-method';
import { SuggestedAmount } from '../models/suggested-amount.model';

@Injectable()
export class SuggestedAmountsEntityService {

  private readonly _defaultBaseUrl = `${environment.apiURL}/administration/`;

  private _baseUrl!: string;

  constructor(private readonly _client: HttpClient, @Inject(SUGGESTED_AMOUNT_SERVICE_ENTITY_CONFIG) private _entity: string) {
    this._baseUrl = this._defaultBaseUrl + this._entity;
  }  

  getSuggestedAmounts(
    entityId: string | null,
    targetType: string
  ): Observable<SuggestedAmount[]> {
    return this._client
      .get<{ data: SuggestedAmount[] }>(
        `${this._baseUrl}/${entityId}/type/${targetType}/suggested-amounts`
      )
      .pipe(map((response) => response.data));
  }

  getSuggestedAmountById(
    profileId: string | null,
    targetType: string,
    suggestedAmountId: string | null
  ): Observable<PaymentMethod> {
    return this._client
      .get<{ data: PaymentMethod }>(
        `${environment.apiURL}/administration/profile/${profileId}/type/${targetType}/suggested-amounts/${suggestedAmountId}`
      )
      .pipe(map((response) => response.data));
  }

  updateSuggestedAmount(
    entityId: string | null,
    targetType: string,
    suggestedAmount: SuggestedAmount
  ): Observable<PaymentMethod> {
    return this._client
      .put<{ data: PaymentMethod }>(
        `${this._baseUrl}/${entityId}/type/${targetType}/suggested-amounts/${suggestedAmount.suggestAmountId}`,
        suggestedAmount
      )
      .pipe(map((response) => response.data));
  }

  createSuggestedAmount(
    entityId: string | null,
    targetType: string,
    suggestedAmount: SuggestedAmount
  ): Observable<PaymentMethod> {
    return this._client
      .post<{ data: PaymentMethod }>(
        `${this._baseUrl}/${entityId}/type/${targetType}/suggested-amounts`,
        suggestedAmount
      )
      .pipe(map((response) => response.data));
  }

  deleteSuggestedAmount(
    entityId: string | null,
    targetType: string,
    suggestAmountId: number
  ): Observable<PaymentMethod> {
    return this._client
      .delete<{ data: PaymentMethod }>(
        `${this._baseUrl}/${entityId}/type/${targetType}/suggested-amounts/${suggestAmountId}`
      )
      .pipe(map((response) => response.data));
  }

}
